import { GatheringsPage } from './gatherings-page';

export const ProgramsPage = () => <GatheringsPage kind="program" />;
